<template>
    <div class="coursePay">
        <Contract  v-if="showContract" @isShowContract="handleIsShowContract"></Contract>
        <div class="courseBack">
            <img
                class="arrow"
                @click="back"
                src="@/assets/images/left.png"
            />
        </div>
        <div class="coursePay-Info">
            <img class="Info-Img" :src="payData.picUrl" alt />
            <div class="Info-bottom">
                <div class="bottom-left">
                    <p class="currentPrice">{{ payData.isFree?'免费':'￥'+payData.salePrice }}</p>
                    <p class="originalCost deltext" v-if="!payData.isFree&&payData.basePrice">
                        ￥{{ payData.basePrice }}
                    </p>
                </div>
                <div class="bottom-right">
                    <p class="right-title">{{ payData.name }}</p>
                    <p class="originalCost" v-if="payData.validityType === 1">
                        有效期：长期有效
                    </p>
                    <p class="originalCost" v-else-if="payData.validityType === 2">
                        有效期：{{payData.startTime | standardTime}}-{{payData.endTime | standardTime}}
                    </p>
                    <p class="originalCost" v-if="payData.validityType === 4">
                        有效期：报名后{{payData.days}}天内有效
                    </p>
                </div>
            </div>
        </div>
        <div class="coursePay-introduction">
            <div class="coursePay-title">
                <h3>
                    <img src="../asset/images/titleIcon@3x.png" alt />
                    项目介绍
                    <img src="../asset/images/titleIcon@3x.png" alt />
                </h3>
            </div>
            <img
                class="project_introduction_img"
                src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/project_introduction.png"
            />
            <div class="title">《人工智能应用管理师职业能力等级评价项目》</div>
            <div class="text">是由工业和信息化部教育与考试中心（CEIAEC）面向人工智能行业从业者推出的职业能力等级评定项目。该项目面向当前人工智能应用管理人才极度紧缺的现状，弥补了权威性人工智能人才能力培养体系和评价体系标准的空白，作为国内人工智能领域首个职业能力等级评价标准。为人工智能人才培养，人才评估和企业招聘提供了重要的依据。目前，《人工智能应用管理师职业能力等级评价证书》已经得到越来越多用人单位的认可，助力求职者实现更高职业梦想。
        </div>
        </div>
        <div class="coursePay-trait">
            <div class="coursePay-title">
                <h3>
                    <img src="../asset/images/titleIcon@3x.png" alt />
                    课程定位
                    <img src="../asset/images/titleIcon@3x.png" alt />
                </h3>
            </div>
            <ul>
                <li
                    v-for="(item, index) in courseTraitList"
                    :key="index"
                    :style="{ backgroundImage: `url(${item.img})` }"
                >
                    <h4
                        :class="
                            [0, 3 , 4].includes(index) ? 'h4title1' : 'h4title2'
                        "
                    >
                        {{ item.title }}
                    </h4>
                    <p>{{ item.content }}</p>
                </li>
            </ul>
        </div>
        <div class="coursePay-sudents">
            <img
                src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/sudents.png"
            />
        </div>
        <div class="coursePay-schedule">
            <img
                src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/study_schedule.png"
            />
        </div>
        <div class="coursePay-studyPlan">
            <div class="coursePay-title">
                <h3>
                    <img src="../asset/images/titleIcon@3x.png" alt />
                    课程大纲与学习安排
                    <img src="../asset/images/titleIcon@3x.png" alt />
                </h3>
            </div>
            <div class="studyPlan-collapse">
                <van-collapse
                    @change="changeCollapse"
                    v-model="activeNames"
                    accordion
                >
                    <van-collapse-item
                        v-for="(item, index) in planList"
                        :key="index"
                        :title="item.stageName"
                        :name="index"
                    >
                        <template slot="title">
                            <span class="stage">
                                {{item.stageNum}}：
                            </span>
                            <span class="name">
                                {{item.stageName}}
                            </span>
                        </template>
                        <div class="info">
                            {{item.describe}}
                        </div>
                        <div :class="index==4?'text last_text':'text'" v-if="index==4">
                            {{item.text}}
                        </div>
                    </van-collapse-item>
                </van-collapse>
            </div>
        </div>
        <div class="coursePay-study_information">
            <img
                src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/study_information.png"
            />
        </div>
        <div class="coursePay-learning_gain">
            <img
                src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/learning_gain_one.png"
            />
        </div>
        <div class="coursePay-btn">
            <p class="newbtn" @click="goPayment" v-if="status == 1 && isStudy">
                立即报名<span v-if="!payData.isFree">¥{{ payData.salePrice }}</span
                ><label v-if="!payData.isFree && payData.basePrice">¥{{ payData.basePrice }}</label>
            </p>
            <p class="newbtn btn-gray" v-else-if="isStudy && status == 0">
                报名已结束
            </p>
            <p class="newbtn" @click="goStudy" v-else-if="!isStudy && status == 1">立即学习</p>
            <p class="newbtn btn-gray" v-else-if="!isStudy && status == 0">
                商品已下架
            </p>
            <p class="newbtn btn-gray" v-else>
                商品未上架
            </p>
            <div class="contract" @click="showContract=true">《培训服务协议》</div>
        </div>
    </div>
</template>

<script>
//第二个课程详情页
//首页点击课程详情
import { Collapse, CollapseItem } from "vant";
import homedata from "../asset/js/mock.js";
import contract from './contractTwo';
import { Toast } from 'vant';
export default {
    name: "secondCoursePay",
    data() {
        return {
            showContract:false,//服务协议显隐
            playerOptions: {
                // playbackRates : [ 0.5, 1.0, 1.5, 2.0 ], //可选择的播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 视频一结束就重新开始。
                // preload : 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                // aspectRatio : '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "",
                        src:
                            "https://platform-vod.wdcloudnet.com/249a7c9a61c24831ae71ca847c7dadd5/86a9f914199048e2956c396592b102c3-e58988aa1706770a7ce9f78a715906f5-sd.mp4" //url地址
                    }
                ],
                poster:
                    "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/video1.jpg", //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, //当前时间和持续时间的分隔符
                    durationDisplay: true, //显示持续时间
                    remainingTimeDisplay: false, //是否显示剩余时间功能
                    fullscreenToggle: false //全屏按钮
                }
            },
            playerOptions2: {
                // playbackRates : [ 0.5, 1.0, 1.5, 2.0 ], //可选择的播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 视频一结束就重新开始。
                // preload : 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                // aspectRatio : '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "",
                        src:
                            "https://platform-vod.wdcloudnet.com/7872c029c7494fd1ac23877f9f66b753/1659ba05f4f14af386d057423f1e7005-913bf4305510a0f3ce50b29e4444a492-sd.mp4" //url地址
                    }
                ],
                poster:
                    "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/video2.jpg", //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, //当前时间和持续时间的分隔符
                    durationDisplay: true, //显示持续时间
                    remainingTimeDisplay: false, //是否显示剩余时间功能
                    fullscreenToggle: false //全屏按钮
                }
            },
            showCoverImg: true,
            showCoverImg1: true,
            activeNames: 0,
            homedata: homedata,
            activeChapter: 1,
            currentChapter: {},
            activeCase: 1,
            currentCase: {},
            token: null,
            trainInfo: {},
            coursePayid: "",
            payData: {},
            isStudy: true, //true 表示可购买，false 表示不可购买，可以直接学习
            videos: null,
            myPlayer1: null,
            myPlayer2: null,
            status: 1, ////0表示下架；1表示上架
            isStudyText: "",
            courseTraitList:[
                {
                    img:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/location1.png',
                    title:'工信部配套课程',
                    content:'是工信部教育与考试中心《人工智能应用管理师职业能力等级评价标准》的配套培训课程'
                },
                {
                    img:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/location2.png',
                    title:'严扣知识技能要求',
                    content:'课程严扣《职业标准》对初级人工智能应用管理师的知识和技能要求'
                },
                {
                    img:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/location3.png',
                    title:'理实结合、循序渐进',
                    content:'以理实结合、循序渐进的方式展开学习'
                },
                {
                    img:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/location4.png',
                    title:'快速掌握知识和技能',
                    content:'帮助学员快速掌握《职业标准》规定的相关知识和技能'
                },
                {
                    img:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/location1.png',
                    title:'提升考试通过率',
                    content:'并通过考前辅导、模拟考试等形式提升评价考试通过率'
                },
                {
                    img:'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/secondCoursePay/location2.png',
                    title:'顺利取得证书',
                    content:'顺利取得由工信部教育与考试中心颁发的《人工应用管理师(初级)职业能力证书》'
                },
            ],
            planList:[
                {
                    id: 1,
                    stageNum: '阶段一',
                    stageName: '《Python编程基础》',
                    describe: 'Python是人工智能领域最常用的编程语言之一，本课程以案例方式帮助学员快速掌握Python核心编程知识，熟悉语言特点和编程规范，掌握基础编程能力和技巧，为后续课程的学习打下基础。',
                },
                {
                    id: 2,
                    stageNum: '阶段二',
                    stageName: '《数据采集与处理》',
                    describe: '数据是人工智能的基础资源，数据的质量直接影响着AI算法的性能，本课程将学习重要的数据采集和处理知识，学员将掌握如何通过ETL工具、网络爬虫等方法采集和获取数据，以及如果通过清洗、转换等方法处理数据。',
                },
                {
                    id: 3,
                    stageNum: '阶段三',
                    stageName: '《数据标注工程》',
                    describe: '数据标注员工/数据标注工程师是人工智能产业发展催生出来的新兴岗位，人才缺口较大。本课程包括数据标注工具的使用、数据标注场景、数据标注案例实战、数据标注平台使用、数据标准管理等内容，帮助学员快速掌握数据标注工作相关的主要知识和技能。',
                },
                {
                    id: 4,
                    stageNum: '阶段四',
                    stageName: '《系统部署与运维》',
                    describe: '本课程主要面向人工智能信息系统相关的运营维护、技术支持等工作需求，包括linux运维管理、web服务器运维、大数据运维、docker运维、自动化运维管理等内容。',
                },
                {
                    id: 5,
                    stageNum: '阶段五',
                    stageName: '《AI开放能力平台应用》',
                    describe: '运用主流的AI开放能力平台实现图像、语音、自然语言处理等人工智能应用是初级人工智能应用管理师的重要能力要求，本课程通过多个案例介绍主流AI开放能力平台（百度、腾讯AI开放平台等）的算法功能，以及API接口调用方法，基于开放能力实现AI应用。',
                    text:'说明：线上学习有效期1年，学员自由安排时间，学习期间教务汇总学习情况灵活安排直播答疑与考前辅导（考前辅导一般安排在评价考试前一周）。'
                },
            ],
        };
    },
    watch: {},
    components: {
        Contract:contract
    },
    filters: {
        standardTime(val) {
            if (val) {
                return val.split(' ')[0].split('-').join('/')
            } else {
                return ""
            }
        },
    },
    destroyed() {
        if (this.$refs.videoPlayer1 || this.$refs.videoPlayer2) {
            this.$refs.videoPlayer1.player.pause();
            this.$refs.videoPlayer2.player.pause();
        }
        window.removeEventListener("popstate", this.backChange1, false); //false阻止默认事件
    },
    methods: {
        handleIsShowContract(data){
            this.showContract = data
        },
        // 时间换算
        formatime(val) {
            let mouth = val ? val.split(" ")[0].split("-")[1] : "";
            let day = val ? val.split(" ")[0].split("-")[2] : "";
            return mouth + "月" + day + "日";
        },
        coverPlayVideo(name) {
            if (name === "one") {
                this.showCoverImg = false;
                this.showCoverImg1 = true;
                this.$refs.videoPlayer1.player.play();
                this.$refs.videoPlayer2.player.pause();
            } else {
                this.showCoverImg1 = false;
                this.showCoverImg = true;
                this.$refs.videoPlayer2.player.play();
                this.$refs.videoPlayer1.player.pause();
            }
        },
        back() {
            this.$router.push({ path: "/" });
        },
        goStudy() {
            if(this.payData.goodsType==1){//训练营
                this.$router.push({
                    path: "/learning/Details",
                    query: {
                        id: this.payData.referId,
                        backPath:this.$route.path
                    }
                });
            }else if(this.payData.goodsType==2){//培训任务
                this.$router.push({
                    path:'/learning/Detailstrain',
                    query:{
                        id:this.payData.referId,
                        backPath:this.$route.path
                    }
                })
            }else if(this.payData.goodsType==3){//测评
                this.$router.push({
                    path:'/humanResting/hrDetails',
                    query:{
                        id:this.payData.referId,
                        refId:this.payData.id,
                        refType:2,
                        pathName:this.$route.path
                    }
                })
            }
        },
        goPayment() {
            if (!this.token) {
                console.log("this.$route",this.$route)
                if(this.$route.path=='/second_CoursePay'){
                    this.$router.push({
                        path: "/login",
                        query: { name: "second_CoursePay" }
                    });
                }else{
                    this.$router.push({
                        path: "/login",
                        query: { name: "gongxin_coursePay" }
                    });
                }
            } else {
                if(this.payData.isFree){
                    this.$api.home.order({
                        goodsId:this.payData.id,
                        orderSource:2
                    }).then(data=>{
                        if(data.code==0){
                            Toast.success('报名成功');
                            setTimeout(()=>{
                                this.goStudy();
                            },1000)
                        }else{
                            console.log(data)
                        }
                    })
                }else{
                    this.$api.home.order({
                        goodsId:this.payData.id,
                        orderSource:2
                    }).then(res=>{
                        if(res.code==0){
                            if(res.data && res.data.realPayPrice !== 0 && String(res.data.orderNo)){
                                localStorage.setItem("goodsOrderInfo",JSON.stringify(res.data))
                                this.$router.push({
                                    path: "/gongxin_payment",
                                    query: {
                                        id: this.payData.id,
                                        iswx: 0,
                                        orderNo:res.data.orderNo
                                    }
                                });
                            }else{
                                if(res.data.url) {
                                    window.open(res.data.url, '_self')
                                    } else {
                                    this.$notify(res.message);
                                    this.$router.go(-1)
                                }
                            }
                        }
                    })
                }
                
            }
        },
        // changeCollapse(val) {
        //     this.activeChapter = 1;
        //     this.getCurrentChapter();
        // },
        // getCurrentChapter(val) {
        //     this.activeChapter = val === undefined ? 1 : val.id;
        //     this.currentChapter =
        //         val === undefined ? homedata.planList[0].chapterList[0] : val;
        // },
        changeCollapse(val) {
            this.activeNames = val || 0;
            this.getCurrentChapter();
        },
        getCurrentChapter(item, index) {
            let index1 = 0;
            index1 = index === undefined ? 0 : index;
            this.activeChapter = item ? item.id : 1;
            this.$nextTick(() => {
                this.currentChapter =
                    homedata.planList[this.activeNames].chapterList[index1];
            });
            // this.currentChapter = val === undefined ? homedata.planList[0].chapterList[0] : val;
        },
        getCurrentCase(val) {
            this.currentCase = val === undefined ? homedata.caseList[0] : val;
            this.activeCase = val === undefined ? 1 : val.id;
        },
        getCourseInfo() {
            this.$api.home.findIndexTrain().then(data => {
                let nodata = {
                    name: "人工智能工程技术人员培训（2020秋季期）",
                    trainStartTime: "2021-01-09 00:00:00",
                    trainEndTime: "2021-02-06 23:59:59"
                };
                this.trainInfo =
                    data.data === null || data.data === "null"
                        ? nodata
                        : data.data;
            });
        },
        backChange1() {
            if(!this.showContract){
                this.$router.push({
                    name: "gongxin_homepage"
                });
            }else{
                this.showContract = false;
                if (window.history && window.history.pushState) {
                    // 往历史记录里面添加一条新的当前页面的url
                    history.pushState(null, null, document.URL);
                    // 给 popstate 绑定一个方法 监听页面刷新
                    window.addEventListener("popstate", this.backChange1, false); //false阻止默认事件
                }
            }
        },
        // findSaleGoodsPay() {
        //     this.$api.home.findSaleGoods().then(data => {
        //         this.trainInfo.id = data.data.id;
        //         this.status = data.data.status;
        //         this.findGoodsById(this.trainInfo.id);
        //     });
        // },
        findSaleGoodsPay() {
            // this.trainInfo.id = this.$route.query.id
            // this.status = this.$route.query.status;
            this.trainInfo.id = sessionStorage.getItem('secondCourserPayId')
            this.status = sessionStorage.getItem('secondCourserPayStatus')
            this.findGoodsById(this.trainInfo.id);
        },
        findGoodsById(id) {
            let params = {
                id: id //this.$route.query.id
            };
            this.$api.home.findGoodsById({ params }).then(data => {
                this.payData = data.data;
                if (this.token) {
                    this.checkUserCanByGoods(this.payData.id);
                } else {
                    this.isStudyText = "立即报名";
                }
            });
        },
        checkUserCanByGoods(id) {
            //查看商品是否购买；
            let params = {
                goodsId: id
            };
            this.$api.home.checkUserCanByGoods({ params }).then(data => {
                this.isStudy = data.data;
                if (this.isStudy) {
                    this.isStudyText = "立即报名";
                } else {
                    this.isStudyText = "立即学习";
                }
            });
        },

        // playVideo(name){
        //     if(name === 'one'){
        //         // console.log(this.$refs.videoplay2)
        //         this.$refs.videoplay2.pause();
        //         this.showCoverImg1 = true;
        //     } else if(name === 'two'){
        //         // console.log(this.$refs.videoplay1)
        //         this.$refs.videoplay1.pause();
        //         this.showCoverImg = true;
        //     }
        // }
    },
    mounted() {
        this.findSaleGoodsPay();
        this.getCourseInfo();
        this.changeCollapse();
        this.getCurrentCase();

        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.backChange1, false); //false阻止默认事件
        }
        this.token = localStorage.getItem("token")
            ? localStorage.getItem("token")
            : null;
    }
};
</script>
<style lang="less">
video::-webkit-media-controls-fullscreen-button {
    display: none;
}

.coursePay {
    .coursePay-audition {
        .auditionList {
            #myVideo1_html5_api {
                border-radius: 14px !important;
            }
            #myVideo2_html5_api {
                border-radius: 14px !important;
            }
            .vjs-poster {
                border-radius: 14px !important;
            }
            .itemvideo {
                video {
                    // width: 96% !important;
                    margin: auto;
                }
            }
            .video-js.vjs-fluid {
                height: 100%;
            }
            // 隐藏播放按钮
            .vjs-custom-skin > .video-js .vjs-big-play-button {
                display: none;
            }
            .video-player {
                height: 100%;
            }
            video:focus {
                outline: none !important;
            }
            .vjs-big-play-centered .vjs-big-play-button {
                display: none;
            }
            .myVideo1-dimensions.vjs-fluid {
                padding-top: 71.25%;
            }
            .myVideo2-dimensions.vjs-fluid {
                padding-top: 71.25%;
            }
            .video-js .vjs-fullscreen-control {
                display: none !important;
            }
            .video-js .vjs-picture-in-picture-control {
                display: none !important;
            }
        }
    }

    .coursePay-studyPlan {
        .studyPlan-collapse {
            .van-cell {
                margin-top: 0.213333rem;
                height: 2.29rem;
                font-size: 0.693333rem;
                color: #666;
                line-height: inherit;
                border-radius: 8px;
                align-items: center;
            }

            .van-cell::after {
                border-bottom: 0px !important;
            }

            .van-cell__left-icon,
            .van-cell__right-icon {
                font-size: 14px !important;
            }

            .van-collapse-item__content {
                padding-top: 0px;
                border-radius: 0px 0px 8px 8px;
            }

            .van-collapse-item__title--expanded {
                background: #fff2e9;
                color: #f47700;
                font-weight: 550;
            }

            .van-collapse-item__title--expanded .van-cell__right-icon::before {
                color: #f47700;
            }

            .van-collapse-item--border::after {
                border-top: 0px !important;
            }

            .van-hairline--top-bottom::after,
            .van-hairline-unset--top-bottom::after {
                border-width: 0px !important;
            }
        }
    }
}
</style>
<style scoped lang="less">
@import url("../asset/css/secondCoursePay");
</style>
